import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUndo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_3809_493162)",
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 32,
				rx: 4,
				fill: "transparent"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M16.1992 13.375C14.2117 13.375 12.4117 14.1175 11.0242 15.325L8.32422 12.625V19.375H15.0742L12.3592 16.66C13.4017 15.79 14.7292 15.25 16.1992 15.25C18.8542 15.25 21.1117 16.9825 21.8992 19.375L23.6767 18.79C22.6342 15.6475 19.6867 13.375 16.1992 13.375Z",
				fill: "currentColor"
			})]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 31,
			height: 31,
			rx: 3.5,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3809_493162",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 32,
				rx: 4,
				fill: "white"
			})
		}) })
	]
});
export default SvgUndo;
